import React from "react";
import Footer from "../components/footer/Footer";
import Header from "../components/nav/Header";

function AppLayout(props) {
  const { children } = props;
  return (
    <>
      <Header />

      {children}

      {typeof SuperAppJsChannel === "undefined" && <Footer />}
    </>
  );
}
export default AppLayout;
